<template>
  <div>
    <div class="row">
      <div class="col">
        <button @click="goBack()" class="btn btn-secondary m-3">Back</button>
      </div>
    </div>
    <div class="row align-items-center m-3">
      <div class="col">
        <div>
          <p class="h1 t-race" style="white-space: pre-line">
            {{ this.getReportName }}
          </p>
        </div>
      </div>
    </div>
    <div class="row align-items-center m-3">
      <div class="col">
        <div>
          <div class="dropdown show">
            <a
              class="btn btn-secondary dropdown-toggle"
              @click="toggleDropdown()"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              EXPORTS
            </a>

            <div
              v-bind:class="dropdownToggle"
              aria-labelledby="dropdownMenuLink"
            >
              <a @click="openLink('CSV')" class="dropdown-item" href="#">CSV</a>
              <a @click="openLink('XL')" class="dropdown-item" href="#"
                >Excel</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="displayBox table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th rowspan="3">
              Finishing <br />
              Order
            </th>
            <th rowspan="3" colspan="1">Horse No.</th>
            <th rowspan="3">Horse</th>
            <th :colspan="numberOfSections">
              Running Position & Margin Behind Leader
            </th>
            <th rowspan="3">Time</th>
          </tr>
          <tr>
            <th :colspan="numberOfSections">Sectional Time</th>
          </tr>
          <tr>
            <th v-for="n in numberOfSections" :key="n">Sect. {{ n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lineItem, index) in this.reportDisplayData" :key="index">
            <td>{{ lineItem.finishingOrder }}</td>
            <td>{{ lineItem.horseNo }}</td>
            <td>
              <div class="horse-details">
                <div class="horse-name-area">
                  <span>{{ lineItem.horse }}</span>
                </div>
                <div class="trainer-jockey-area">
                  <div class="trainer">
                    ({{ lineItem.weight }}kg)
                    {{ lineItem.jockey }}
                    {{ lineItem.trainer == null ? "" : "/" }}
                    {{ lineItem.trainer }}
                  </div>
                </div>
              </div>
            </td>

            <td v-for="(data, index) in lineItem.reportData" :key="index">
              <div style="background-color: #dcdcdc">
                <div
                  style="
                    font-size: 0.8em;
                    display: flex;
                    justify-content: center;
                    margin-left: 20px;
                  "
                ></div>
                <div style="display: flex; justify-content: center">
                  {{ data[`positionAtTheEndOfSection_${index}`] }}
                </div>
              </div>
              <div>
                <div style="display: flex; justify-content: center">
                  {{ data[`totalSectionTime_Section_${index}`] }}
                </div>
                <div
                  style="
                    font-size: 0.8em;
                    display: flex;
                    justify-content: space-between;
                    margin: -10px 10px 0 10px;
                  "
                >
                  <div>
                    {{
                      data[`firstHalfTime_Section_${index}`]
                        ? data[`firstHalfTime_Section_${index}`]
                        : "-"
                    }}
                  </div>
                  <div>
                    {{
                      data[`secondHalfTime_Section_${index}`]
                        ? data[`secondHalfTime_Section_${index}`]
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </td>
            <td>{{ lineItem.time }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { config } from "../../config";

export default {
  name: "PositionAndMarginBehindReport",
  data() {
    return {
      dropdownToggle: "dropdown-menu",
      dropdownStatus: false,
      raceDistance: 1400,
      numberOfSections: 0,
      remainderSectionDistance: 0,
      chunkedArray: [],
      reportDisplayData: undefined,
    };
  },
  methods: {
    /**
     * This method get the sectional data taking the race distance into account. A section is defined
     * as 400m so the amount of sections is equal to the raceDistance / 400. If there is a remainder that would be a seperate section eqaul to the remainder value.
     */
    getSectionalInfo(raceDistance) {
      const SECTION_LENGTH = 400;
      let sections = Math.floor(raceDistance / SECTION_LENGTH);
      let remainingSections = raceDistance % SECTION_LENGTH;
      if (remainingSections > 1) {
        sections = sections + 1;
      }
      this.numberOfSections = sections;
    },
    roundTime(val) {
      return val.toFixed(3);
    },

    /**
     * This method breaks down the sectionalData in the data object and organises is in chunks according to the number
     * of sections available for this race.
     */
    getSectionalData() {
      this.reportDisplayData = this.getPositionAndMarginBehindData;
      this.getSectionalInfo(
        this.reportDisplayData[Object.keys(this.reportDisplayData)[0]]
          .raceDistance
      );
    },
    goBack() {
      this.$router.push("/landing/PositionAndMarginBehindFilter");
    },
    getCleanReportHeaders() {
      let HeaderArray = [];
      let ValidPush = true;
      this.getReportSectionalHeaders[0].raceHeaders.forEach((item) => {
        ValidPush = false;
        if (item.match(/0t$/)) {
          item = `${item.match(/\d+/)[0]}m-Finish`;
          ValidPush = true;
        }
        if (item.match(/To1000m$/)) {
          item = `${item.match()}Start-1000m`;
          ValidPush = true;
        }
        if (ValidPush) {
          HeaderArray.push(item);
        }
      });
      return HeaderArray;
    },

    toggleDropdown() {
      this.dropdownStatus = !this.dropdownStatus;
      this.dropdownToggle = this.dropdownStatus
        ? "dropdown-menu show"
        : "dropdown-menu";
    },
    columnsDisplayCleaner(row) {
      var tempArray = [];
      // eslint-disable-next-line no-console
      let tempRow = Object.assign({}, row);
      // eslint-disable-next-line no-console
      var t = this.dateHeader(tempRow.meetingDate);

      tempRow.meetingDate = t;
      delete tempRow.meetingDate;
      delete tempRow.race;
      delete tempRow.raceCourse;
      let tempJockeyAndTrainerDetails = {
        Jockey: tempRow.jockey,
        Trainer: tempRow.trainer,
      };
      delete tempRow.jockey;
      delete tempRow.trainer;

      row = tempRow;

      let tempWeightAllowedAltered = {
        Jockey: tempRow.weightAllowed,
        Trainer: null,
      };

      delete tempRow.weightAllowed;

      for (var key in row) {
        // eslint-disable-next-line no-console
        if (
          this.getReportSectionalHeaders[0].raceHeaders.filter(
            (x) => x.toLowerCase() == key.toLowerCase()
          ).length > 0
        ) {
          if ((key == "horse") | (key == "weight")) {
            if (key == "weight") {
              tempArray.push({
                value: row[key],
                isGroup: true,
                groupValues: tempWeightAllowedAltered,
              });
            }

            if (key == "horse") {
              tempArray.push({
                value: row[key],
                isGroup: true,
                groupValues: tempJockeyAndTrainerDetails,
              });
            }
          } else {
            tempArray.push({
              value: row[key],
              isGroup: false,
            });
          }
        }
      }
      // eslint-disable-next-line no-console
      return tempArray;
    },
    titleCleaner(title) {
      return title.replaceAll("$$", this.getReportSectional[0].race);
    },
    dateHeader(mdate) {
      // eslint-disable-next-line no-console
      let validDate = new Date(mdate);

      let month = validDate.getMonth() + 1;
      let day = validDate.getDate();
      let year = validDate.getFullYear();

      return `${year}-${month >= 9 ? month : `0${month}`}-${
        day >= 9 ? day : `0${day}`
      }`;
    },

    openLink(fileType) {
      window.open(
        `${config.reportingURL}/api/Reports/RunningPositionAndMarginBehindLeaderFile?startTime=${this.getReportRaceDate}&rc=${this.getReportRacecourse}&rn=${this.getRaceNumber}&fileType=${fileType}`,
        "_blank"
      );
    },

    headerNameSantizer(colName) {
      return colName.replaceAll("_", "");
    },
  },
  computed: {
    ...mapGetters([
      "getPositionAndMarginBehindData",
      "getReportName",
      "getReportRaceDate",
      "getReportRacecourse",
      "getReportRacesArray",
      "getRaceNumber",
    ]),
  },
  mounted() {
    this.getSectionalData();
  },

  areAllNumericValues(columnIndex) {
    // Check if all values in the column are numeric
    return this.getReportSectional.every(
      (item) => !isNaN(parseFloat(item[columnIndex]))
    );
  },

  calculateColumnAverage(columnIndex) {
    // Calculate the average of the specified column
    const total = this.getReportSectional.reduce(
      (sum, item) => sum + parseFloat(item[columnIndex] || 0),
      0
    );
    const average = total / this.getReportSectional.length;

    // Round the average to 2 decimal places
    return average.toFixed(2);
  },
};
</script>

<style scoped>
.horse-details {
  display: flex;
  flex-direction: column;
}
.table {
  border-collapse: separate;
  border-spacing: 2px;
}
.trainer-jockey-area {
  display: flex;
  flex-direction: row;
  font-style: italic;
  color: grey;
  margin-inline: auto;
}

.trainer,
.jockey {
  padding-inline: 0.3rem;
  font-size: 0.69rem;
}

.trainer {
  padding-right: 0.5rem;
}

.displayBox {
  max-height: 80vh;
  width: 95%;
  overflow: scroll;
  margin-inline: auto;
}

th {
  color: white !important;
  text-align: center;
  font-weight: bold;
  background-color: #4caee3 !important;
}

tr:hover {
  background-color: black;
  color: white;
}

.t-race {
  text-align: center;
}

td {
  text-align: center;
}
.table td,
.table th {
  padding: 0.3rem;
  vertical-align: bottom;
  border-top: 1px solid #dee2e6;
}
.container {
  width: 100% !important;
}

.three {
  width: 25%;
  background: linear-gradient(
    to top right,
    #fff calc(50% - 1px),
    #aaa,
    #fff calc(50% + 1px)
  );
}

.diagonal-line {
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 70%;

  position: relative;
  background-color: lightgray;
}

.diagonal-line::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-left: 2px solid black;
  border-top: 2px solid transparent;
  transform: rotate(45deg);
  transform-origin: 0 100%;
}
</style>
